module.exports = __webpack_public_path__ + "fonts/DINPro.177160bc.woff";